import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as API from '../../../Endpoints/endpoint';
import { useParams } from 'react-router-dom';

function ViewPoster() {
  const { srno } = useParams();
  const [poster, setPoster] = useState(null);

  useEffect(() => {
    fetchPoster();
  }, []);

  const fetchPoster = async () => {
    try {
      const res = await axios.get(`${API.GET_POSTER_BY_ID}/${srno}`);
      setPoster(res.data);
    } catch (err) {
      console.error(err);
      alert('Failed to fetch poster.');
    }
  };

  return (
    <div className="view-container">
      <h2>Poster Details</h2>
      {poster ? (
        <ul>
          {Object.entries(poster).map(([key, value]) => (
            <li key={key}><strong>{key}</strong>: {value}</li>
          ))}
        </ul>
      ) : (
        <p>Loading poster info...</p>
      )}
    </div>
  );
}

export default ViewPoster;
